import { createSelector } from 'reselect'
import { identity } from 'ramda'

const errorsSelector = (state) => state.getIn(['validation', 'errors'])
const dirtySelector = (state) => state.getIn(['validation', 'dirty'])

const getHasErrors = createSelector(
  errorsSelector,
  (_, { id }) => id,
  (errors, id) => errors.has(id)
)

export const makeGetHasErrors = () => getHasErrors

export const getInErrorState = createSelector(
  errorsSelector,
  (errors) => !errors.isEmpty()
)

export const getValidationErrors = createSelector(errorsSelector, identity)

export const getInDirtyState = createSelector(
  dirtySelector,
  (dirty) => !dirty.isEmpty()
)

export const getDirtyIds = createSelector(dirtySelector, (dirty) =>
  dirty.toJS()
)
